import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Debugger} from "debug";
import IResourceArray = ng.resource.IResourceArray;

const debug: Debugger = require('debug')('AvstemningRessurs');

export class AvstemningRessurs extends BasisRessurs<l.AvstemningMedResultatModell> {

    static regNavn = 'AvstemningRessurs';

    static forInjisering() {
        return [
            '$resource',
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            AvstemningRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService, ressursFeilhåndtering: RessursFeilhåndtering, gettextCatalog: gettextCatalog) {
        super('avstemning',
            $resource,
            ressursFeilhåndtering,
            gettextCatalog,
            {
                finnAvstemningerKnyttetTilMøte: {method: 'GET', url: '/api/avstemning/finnAvstemningerKnyttetTilMoete/:moeteId', params: {moeteId: '@moeteId'}, isArray: true},
                finnAvstemningerBrukerIkkeHarStemtPå: {method: 'GET', url: '/api/avstemning/finnAvstemningerBrukerIkkeHarStemtPaa', isArray: true},
                finnAvstemningerAndreIkkeHarStemtPå: {method: 'GET', url: '/api/avstemning/finnAvstemningerAndreIkkeHarStemtPaa', isArray: true},
                avgiStemme: {method: 'POST', url: '/api/avstemning/:id/avgiStemme', params: {id: '@id'}},
                nullstillAvgitteStemmer: {method: 'DELETE', url: '/api/avstemning/:id/nullstillAvgitteStemmer', params: {id: '@id'}},
                åpneForAvstemning: {method: 'POST', url: '/api/avstemning/:id/aapneForAvstemning', params: {id: '@id'}},
                stengForAvstemning: {method: 'POST', url: '/api/avstemning/:id/stengForAvstemning', params: {id: '@id'}},
            });
    }

    //offentlige metoder

    finnAvstemningerKnyttetTilMøte(møteId: string): IResourceArray<l.AvstemningMedResultatModell> {
        debug("finnAvstemningerKnyttetTilMøte", møteId)
        return this.ressurs['finnAvstemningerKnyttetTilMøte'](
            {moeteId:møteId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke hente avstemninger')));
    }

    finnAvstemningerBrukerIkkeHarStemtPå(): IResourceArray<l.AvstemningMedMøteModell> {
        debug("finnAvstemningerBrukerIkkeHarStemtPå")
        return this.ressurs['finnAvstemningerBrukerIkkeHarStemtPå'](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke hente avstemninger')));
    }

    finnAvstemningerAndreIkkeHarStemtPå(): IResourceArray<l.ManglerStemmegivningModell> {
        debug("finnAvstemningerAndreIkkeHarStemtPå")
        return this.ressurs['finnAvstemningerAndreIkkeHarStemtPå'](
            {},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString('Kunne ikke hente avstemninger')));
    }

    avgiStemme(avstemningId:string, avstemningsalternativId:string): l.AvstemningMedResultatModell{
        debug("avgiStemme", avstemningId, avstemningsalternativId)
        return this.ressurs["avgiStemme"](
            {id: avstemningId, avstemningsalternativId: avstemningsalternativId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke registrer stemme"))
        );
    }

    nullstillAvgitteStemmer(beslutningId: string): l.AvstemningMedResultatModell {
        debug("nullstillAvgitteStemmer", beslutningId)
        return this.ressurs["nullstillAvgitteStemmer"](
            {id: beslutningId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke nullstille avgitte stemmer"))
        );
    }

    åpneForAvstemning(beslutningId: string): l.AvstemningMedResultatModell {
        debug("åpneForAvstemning", beslutningId)
        return this.ressurs["åpneForAvstemning"](
            {id: beslutningId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke åpne for avstemning"))
        );
    }

    stengForAvstemning(beslutningId: string): l.AvstemningMedResultatModell {
        debug("stengForAvstemning", beslutningId)
        return this.ressurs["stengForAvstemning"](
            {id: beslutningId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke stenge for avstemning"))
        );
    }
}


